<template>
  <el-dialog
    title="请注意"
    :visible.sync="currentVisible"
    width="50%">
    <p style="margin-left: 60px">表格中变量字段与历史数据不符，请修改。</p>
    <el-form ref="form"
               :model="form"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="历史变量"
                          prop="name">
              {{fields.join(' ,')}}
            </el-form-item>
            <el-form-item label="上传表格变量">
              {{errorFields.join(' ,')}}
            </el-form-item>
          </div>
        </div>
      </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button el-button @click="currentVisible = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    fields: {
      type: Array,
      default: () => {
        return []
      }
    },
    errorFields: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  data () {
    return {
      form: {},
      currentVisible: this.visible,
    }
  },
  computed: {},
  watch: {
    visible () {
      if (this.currentVisible !== this.visible) {
        this.currentVisible = this.visible
      }
    },
    currentVisible () {
      if (this.currentVisible !== this.visible) {
        this.$emit('update:visible', this.currentVisible)
      }
    },
  },
  created () {},
  mounted () {},
  methods: {
    onSubmit () {
      this.currentVisible = false
      this.$message.success('提交成功！')
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/intelligent-outbound-call/components/UploadErrorDialog.vue